import { Skeleton } from "@/components/ui/skeleton";
import { TableRow, TableCell } from "@/components/ui/table";

export const LoadingInvitationsTable = () => {
  return Array.from({ length: 3 }).map((_, i) => {
    return (
      // eslint-disable-next-line react/no-array-index-key
      <TableRow data-testid="loadingInvitationsTable" key={i}>
        <TableCell className="w-16">
          <Skeleton className="h-12" />
        </TableCell>
        <TableCell>
          <Skeleton className="h-12" />
        </TableCell>
        <TableCell>
          <Skeleton className="h-12" />
        </TableCell>
        <TableCell>
          <Skeleton className="h-12" />
        </TableCell>
      </TableRow>
    );
  });
};
